import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginRequestModel } from '../model/LoginRequestModel';
import { ApiUrls } from './ApiUrls';
import { LoginResponseModel } from '../model/LoginResponseModel';
import { MenuResponse } from '../model/MenuResponse';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private httpClient: HttpClient) { }

  otpVerification(otpVerificationRequest: LoginRequestModel):Observable<object>{
    return this.httpClient.post<LoginResponseModel>(ApiUrls.otpVerification, otpVerificationRequest);

  }

  login(loginRequest: LoginRequestModel):Observable<object>{
    return this.httpClient.post<LoginResponseModel>(ApiUrls.login, loginRequest);
  }

  resendOtp(loginRequest: LoginRequestModel):Observable<object>{
    return this.httpClient.post<LoginResponseModel>(ApiUrls.resendOtp, loginRequest);
  }

  

  fetchMenu() {
    return this.httpClient.get<MenuResponse>(ApiUrls.menuForLoggedInUserUrl);
  }
}
